import type { ReactNode } from 'react';

interface ZoneHeaderProps {
  icon: ReactNode;
  title: string;
  subtitle?: string;
  accentColor: string; // ex: 'brand' | 'blue' | 'slate'
  action?: ReactNode;
  badge?: string;
}

export function ZoneHeader({ icon, title, subtitle, accentColor, action, badge }: ZoneHeaderProps) {
  const accents: Record<string, string> = {
    brand: 'border-brand-200 dark:border-brand-900/50',
    blue: 'border-blue-200 dark:border-blue-900/50',
    slate: 'border-slate-200 dark:border-slate-700',
    violet: 'border-violet-200 dark:border-violet-900/50',
    emerald: 'border-emerald-200 dark:border-emerald-900/50',
  };
  const iconBgs: Record<string, string> = {
    brand: 'bg-brand-50 dark:bg-brand-950/30 text-brand-600 dark:text-brand-400',
    blue: 'bg-blue-50 dark:bg-blue-950/30 text-blue-600 dark:text-blue-400',
    slate: 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400',
    violet: 'bg-violet-50 dark:bg-violet-950/30 text-violet-600 dark:text-violet-400',
    emerald: 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400',
  };

  return (
    <div
      className={`mb-3 flex items-center justify-between border-b-2 pb-3 ${accents[accentColor] ?? accents.slate}`}
    >
      <div className="flex items-center gap-3">
        <div
          className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg ${iconBgs[accentColor] ?? iconBgs.slate}`}
        >
          {icon}
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h2 className="text-lead font-semibold text-slate-800 dark:text-slate-100">{title}</h2>
            {badge && (
              <span className="rounded-full bg-slate-100 px-1.5 py-0.5 text-chip font-medium text-slate-500 dark:bg-slate-800 dark:text-slate-400">
                {badge}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="mt-0.5 text-meta text-slate-400 dark:text-slate-500">{subtitle}</p>
          )}
        </div>
      </div>
      {action}
    </div>
  );
}
